/**
 * Events Archive - Filter, Search & Pagination
 */

import { initArchiveFilter } from './archive-filter.js';
import { revealStagger, motionTokens } from './motion-primitives.js';

document.addEventListener('DOMContentLoaded', () => {
	initArchiveFilter({
		archiveSelector: '.rmh-events-archive',
		gridSelector: '[data-events-grid]',
		countSelector: '[data-events-count]',
		tabSelector: '.rmh-events-tab',
		paginationButtonSelector: '.rmh-events-page-btn',
		scrollTargetSelector: '.rmh-events-tab',
		searchParam: 'event_search',
		errorContext: 'Events filter error',
		gridWrapperClass: 'grid items-start grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 md:gap-y-[72px] lg:grid-cols-3',
		paginationContainerAttr: 'data-events-pagination',
		defaultStrings: {
			noResults: 'No events found.',
			error: 'Something went wrong. Please try again.',
		},
		stringsGlobal: 'rmhEvents',
	});

	// Initial-paint stagger across visible event cards. AJAX-replaced grids
	// don't re-fire — animation on every filter tap would feel chatty.
	const grid = document.querySelector('.rmh-events-archive [data-events-grid] > div');
	if (grid) {
		revealStagger(grid, {
			childSelector: ':scope > *',
			stagger: motionTokens.stagger,
			duration: motionTokens.durMd,
			maxAnimated: 6,
		});
	}
});
